// Affiliate identity constants. These IDs are ALSO hardcoded inside the LLM
// prompt strings (src/app/lib/itinerary/prompt.ts, src/app/api/plan/route.js,
// src/app/api/plan-day/route.js, src/app/api/chat/route.js) because the model
// emits the Viator links itself — that HTML contract is intentionally left
// untouched. Use these constants for any code we control (booking CTAs,
// tracking) and keep them in sync with the prompt strings if the IDs ever
// change.

export const VIATOR_MCID = "42383";
export const VIATOR_PID = "P00153480";
export const VIATOR_MEDIUM = "link";

export const GYG_PARTNER_ID = "JQ8NY6A";

/**
 * Build a Viator affiliate search URL for a whole city — used by the per-day
 * "Book tours & tickets in {city}" CTA. Mirrors the query-param shape the LLM
 * is prompted to emit for individual places.
 */
export function viatorCitySearchUrl(city: string): string {
  const text = encodeURIComponent(city.trim());
  return (
    "https://www.viator.com/searchResults/all" +
    `?mcid=${VIATOR_MCID}&medium=${VIATOR_MEDIUM}&pid=${VIATOR_PID}&text=${text}`
  );
}
